import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '../../../shared/shared.module';

import { PaymentMethodsService } from '../../../../services/financial-accounts/payment-methods.service';

import { DatatableModule } from '../../../shared/datatable/datatable.module';
import { LegfiCurrencyPipe } from '../../../../pipes/format/legfi-currency.pipe';
import { LegfiCurrencyPipeModule } from '../../../../pipes/format/legfi-currency.module';
import { LegfiDatePipe } from '../../../../pipes/format/legfi-date.pipe';
import { LegfiDatePipeModule } from '../../../../pipes/format/legfi-date.module';
import { ModalModule } from '../../../shared/modal/modal.module';
import { OrgBankAccountListComponent } from './org-bank-account-list.component';
import { ChargesService } from '../../../../services/charges/charges.service';
import { PlaidService } from '../../../../services/plaid.service';
import { BankAccountsService } from '../../../../services/financial-accounts/bank-accounts.service';
import { OrganizationService } from '../../../../services/organization/organization.service';


@NgModule({
    imports: [
        // Shared
        SharedModule,
        NgbModule,

        // Dependencies
        DatatableModule,
        ModalModule,
        LegfiCurrencyPipeModule,
        LegfiDatePipeModule,
    ],
    exports: [OrgBankAccountListComponent],
    declarations: [OrgBankAccountListComponent],
    providers: [
        ChargesService,
        BankAccountsService,
        OrganizationService,
        PaymentMethodsService,
        PlaidService,
        LegfiCurrencyPipe,
        LegfiDatePipe,
    ],
})
export class OrgBankAccountListModule
{
}
